// extracted by mini-css-extract-plugin
export default {"container":"week-animation_container__HMJS8","dayWrapper":"week-animation_dayWrapper__o7cXU","dayLabel":"week-animation_dayLabel__N2u78","circle":"week-animation_circle__FaGUN"};